import { ChatInterface } from '../features/chat/components/ChatInterface';
import { ChatProvider } from '../features/chat/context/ChatContext';
import { InstallPromptSheet } from '../components/pwa/InstallPromptSheet';

export const ChatPage = () => {
  return (
    <ChatProvider>
      <ChatInterface />
      <InstallPromptSheet />
    </ChatProvider>
  );
};
